import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAlert,
  FDList,
  FDListItem,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export function ResourcesItemList({ collection, pluralListItemName }) {
  const { loadModalCollectionByLink } = useModalContext();
  if (!collection) {
    return null;
  }

  return (
    <FDList>
      {collection.resources().length() > 0
        ? collection.resources().list().map((el) => (
          <FDListItem
            key={el.id()}
            primaryText={el.attr('title')}
            secondaryText={el.attr('description')}
            icon={el.meta().canSubmit() ? 'edit' : 'visibility'}
            onClick={() => {
              loadModalCollectionByLink(el.link('self').url());
            }}
            inset
          />
        )) : (
          <FDAlert status="warning" title={`No ${pluralListItemName}`} />
        )}
    </FDList>
  );
}

ResourcesItemList.defaultProps = {};

ResourcesItemList.propTypes = {
  collection: PropTypes.object.isRequired,
  pluralListItemName: PropTypes.string.isRequired,
};


const DebtMinPaymentsLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <ResourcesItemList collection={resource.attr('debtMinPayments')} pluralListItemName="Debt Minimum Payments" />
  );
};

const metaOverrideSet = buildFacetDesignOverride();
const DebtMinPaymentsSection = ({
  resource,
}) => {
  if (!resource) {
    return null;
  }

  return (
    <MetaFormInline
      padding="none"
      noIndividualSubmitButtons
      resource={resource}
      layout={DebtMinPaymentsLayout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

DebtMinPaymentsSection.defaultProps = {};

DebtMinPaymentsSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default DebtMinPaymentsSection;
